import styled, { keyframes } from 'styled-components';

import { progressLine } from '../../AiManagerRefact/Model/aiProgressLine';

// 말풍선 밖에서 현재 활동 한 줄만 읽어 준다. 움직임 줄이기 설정도 따른다. //
export default function AiProgressTrail(props) {
  const { items, language, initialText, color } = props;

  return (
    <ProgressWrapper
      role='status'
      aria-live='polite'
      aria-atomic='true'
      $color={color}
    >
      <PulseWrapper aria-hidden='true' />
      <ProgressTextWrapper>{progressLine(items, language, initialText)}</ProgressTextWrapper>
    </ProgressWrapper>
  );
}

const pulse = keyframes`
  0%, 100% { opacity: .35; }
  50% { opacity: 1; }
`;

const gradientSweep = keyframes`
  from { background-position: 0% 50%; }
  to { background-position: 100% 50%; }
`;

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 4px;
  min-width: 0;
  color: ${props => props.$color};
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
`;

const ProgressTextWrapper = styled.span`
  min-width: 0;

  @supports (background-clip: text) or (-webkit-background-clip: text) {
    background-image: linear-gradient(110deg, currentColor 0%, #D96B94 35%, #8B5CF6 65%, currentColor 100%);
    background-size: 300% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradientSweep} 3s ease-in-out infinite alternate;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @media (forced-colors: active) {
    background: none;
    color: CanvasText;
    -webkit-text-fill-color: currentColor;
    animation: none;
  }
`;

const PulseWrapper = styled.span`
  flex: 0 0 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  animation: ${pulse} 1.5s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
